/**
 * Shared prompt section for md_download file handling.
 * Appended to every app's system prompt so the LLM understands
 * how to work with tool-generated files and the md_download URL format.
 */
export const mdDownloadPrompt = `

## Generated Files (md_download)

Tools may generate files (plots, charts, CSVs, PDFs, images, etc.) that cannot be returned inline. These files are stored server-side and referenced via \`md_download/\` URLs.

### How md_download URLs work
- Tool results may contain paths like \`md_download/<session_id>/<filename>\`
- The frontend automatically renders these as downloadable links (for documents/CSVs) or inline images (for PNG/JPG/SVG)
- You do NOT need to construct the full URL — just include the \`md_download/...\` path as a markdown link or image

### Presenting files to the user
- **Images/charts**: Use markdown image syntax: \`![Description](md_download/session_id/chart.png)\`
- **Downloadable files** (CSV, PDF, DOCX, etc.): Use markdown link syntax: \`[filename.csv](md_download/session_id/filename.csv)\`
- Always include a brief description of what the file contains

### Reading generated files for further analysis
When a tool produces a CSV or data file and you need to analyze its contents (e.g., to answer follow-up questions, summarize data, or create charts):
- Use \`CodeExecutionTool\` to read the file by passing the filename
- Example: if a tool returns \`md_download/abc123/results.csv\`, you can read it with CodeExecutionTool using the file path
- Do NOT ask the user to download and re-upload the file — read it directly via tools

### Common patterns
- After generating a chart/plot, show it with \`![](md_download/...)\` AND briefly describe what it shows
- After generating a CSV, link it with \`[Download results](md_download/...)\` AND summarize key findings
- If a tool returns multiple files, present them as a bulleted list of links`;
